import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {TransferCriteriaComponent} from '../transfer-criteria/transfer-criteria.component';
import {
  DataShareService,
  DestinationType, SurfCalendarStartDateService,
  SurfCityPipe,
  SurfCriteriaUtil,
  SurfStaticDataService,
  SurfTextCasePipe, SurfTravellerEarliestDepartureDateService
} from '@surf/surf-components-core';
import {ConfigLoader, DataStore} from '@tc-core/util/framework';
import {DataServiceHandler} from '@tc-core/service/service-handlers';
import {TC} from '@tc-core/util';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'surf-transfer-criteria-dp',
  templateUrl: './transfer-criteria-dp.component.html'
})
export class TransferCriteriaDpComponent extends TransferCriteriaComponent implements OnInit, OnChanges {

  @Input() selectComp = false;              /*needed for dp criteria*/
  @Output() itemRemoved: EventEmitter<any> = new EventEmitter<any>();
  isSelected = false;
  cityPipe: SurfCityPipe;
  msg = '';
  transferHideTimeDetails = false;

  constructor(protected commonService: DataShareService,
              protected dataStore: DataStore,
              protected configLoader: ConfigLoader,
              protected dataServiceHandler: DataServiceHandler,
              public surfCriteriaUtil: SurfCriteriaUtil,
              private surfStaticDataService: SurfStaticDataService,
              protected surfCityPipe: SurfCityPipe,
              protected travellerEarliestDepartureDateService: SurfTravellerEarliestDepartureDateService,
              protected surfCalendarStartDateService: SurfCalendarStartDateService, protected http: HttpClient) {
    super(commonService, dataStore, configLoader, dataServiceHandler, surfCriteriaUtil, surfCityPipe,
      travellerEarliestDepartureDateService, surfCalendarStartDateService, http);
    this.cityPipe = new SurfCityPipe(surfStaticDataService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-transfer-criteria/src/lib/transfer-criteria-dp/transfer-criteria-dp.component.ts.TransferCriteriaDpComponent.ngOnChanges');
    super.ngOnChanges(changes);

    /*if this component is added to the dp criteria panel initially, then it should be selected = true*/
    if (changes.selectComp) {
      this.isSelected = changes.selectComp.currentValue;
    }
  }

  ngOnInit() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-transfer-criteria/src/lib/transfer-criteria-dp/transfer-criteria-dp.component.ts.TransferCriteriaDpComponent.ngOnInit');
    super.ngOnInit();
    this.showPickupTypeAheadContent = true;
    this.showDropoffTypeAheadContent = true;
    this.transferHideTimeDetails = this.configLoader.getModuleConfig('TRS_HIDE_TIME_DETAILS',TC.MODULE_NAME.SURF_B2B) === 'true';
  }

  public selectComponent() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-transfer-criteria/src/lib/transfer-criteria-dp/transfer-criteria-dp.component.ts.TransferCriteriaDpComponent.selectComponent');
    this.isSelected = true;
  }

  public deselectComponent() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-transfer-criteria/src/lib/transfer-criteria-dp/transfer-criteria-dp.component.ts.TransferCriteriaDpComponent.deselectComponent');
    this.isSelected = false;
    this.showPickupTypeAheadContent = false;
    this.showDropoffTypeAheadContent = false;
    this.showPickUpRecommendationList = false;
    this.showDropOffRecommendationList = false;
  }

  removeItem() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-transfer-criteria/src/lib/transfer-criteria-dp/transfer-criteria-dp.component.ts.TransferCriteriaDpComponent.removeItem');
    if (!this.isRefine && !this.isDPSearch && !this.isAmendmentFlow) {
      this.commonService.updateComponentCriteria(null, 'TRS');
    }
    this.itemRemoved.emit(this.index);
  }

  moveToDP(position: string, event: boolean) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-transfer-criteria/src/lib/transfer-criteria-dp/transfer-criteria-dp.component.ts.TransferCriteriaDpComponent.moveToDP');
    if (!this.isRefine && event) {          /*TODO: Implemented for refine*/
      if (!this.isDPSearch) {                     /*Move to DP search panel if only; was in the component flow previously*/
        this.msg = 'DP_Switch~TRS~' + position;
        // this.commonService.changeMessage(msg);
      }
    }
  }

  handleInputFocusOut(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-transfer-criteria/src/lib/transfer-criteria-dp/transfer-criteria-dp.component.ts.TransferCriteriaDpComponent.handleInputFocusOut');
    console.log(event);
    if (event == this.pickupLocationPropId ) {
      if(this.transferCriteria.pickupLocationName && !this.transferCriteria.pickupLocationName.includes('undefined')) {
        this.selectedPickUpPoint.displayText = this.transferCriteria.pickupLocationName;
      }
      else if(this.transferCriteria.pickupLocationName &&
        this.transferCriteria.pickupLocationName.includes('undefined') &&
        this.transferCriteria.pickupCity &&
        !this.transferCriteria.pickupCity.includes('undefined')) {
        this.cityPipe.transform(this.transferCriteria.pickupCity).subscribe(res => {
          this.selectedPickUpPoint.displayText = res;
        });
      }
    } else if (event == this.dropoffLocationPropId) {
      if(this.transferCriteria.dropOffLocationName && !this.transferCriteria.dropOffLocationName.includes('undefined')) {
        this.selectedDropOffPoint.displayText = this.transferCriteria.dropOffLocationName;
      }
      else if(this.transferCriteria.dropOffLocationName &&
        this.transferCriteria.dropOffLocationName.includes('undefined') &&
        this.transferCriteria.dropOffCity &&
        !this.transferCriteria.dropOffCity.includes('undefined')) {
        this.cityPipe.transform(this.transferCriteria.dropOffCity).subscribe(res => {
          this.selectedDropOffPoint.displayText = res;
        })
      }
    }
  }

  /**
   * focus in
   */
  handleInputFocusIn($event, type) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-transfer-criteria/src/lib/transfer-criteria-dp/transfer-criteria-dp.component.ts.TransferCriteriaDpComponent.handleInputFocusIn');
    if (this.pickupLocationPropId === type && !this.transferCriteria.pickupCityName) {
      this.showPickUpRecommendationList = true;
      this.showDropOffRecommendationList = false;
    } else if (this.dropoffLocationPropId === type && !this.transferCriteria.dropOffCityName) {
      this.showPickUpRecommendationList = false;
      this.showDropOffRecommendationList = true;
    }
  }

  passengerSplitChange(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-transfer-criteria/src/lib/transfer-criteria-dp/transfer-criteria-dp.component.ts.TransferCriteriaDpComponent.passengerSplitChange');
    if (event && event.length === this.paxSplitArray.length) {
      this.isPaxSplitChanged.emit(false);
    } else {
      this.isPaxSplitChanged.emit(true);
    }
  }

  /**
   * enable passenger split dropdown
   */
  enablePaxSplitDropdown() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-transfer-criteria/src/lib/transfer-criteria-dp/transfer-criteria-dp.component.ts.TransferCriteriaDpComponent.enablePaxSplitDropdown');
    this.enablePaxSplit = true;
  }
}
